<template>
  <div>
    <v-layout>
      <v-flex md3>
        <h2>SPCI ({{count}})</h2>
      </v-flex>
      <v-flex md9 class="btns">
        <refresh-rq :name="rq_name" :ex_refresh.sync="ex_refresh" />
        <template v-if="!['check_status'].includes(type)">
          <export-ex :ex_permission="13" :name="export_name" :config_name="`${rq_name}/a/all`"/>
          <v-btn color="primary" @click="new_item" :style="dark_t?'color:black':''" v-if="myPermissions.includes(7)">
            <v-icon>add</v-icon>
            <span>Agregar SPCI</span>
          </v-btn>
        </template>
      </v-flex>
    </v-layout>

    <v-layout class="mt-20" wrap>
        <combobox-rq
          :ex_filters="pr_fls"
          class="px-4"
          md="3"
          :multiple="true"
          :main_name="rq_name"
          main_f_key="aes__bcei__name"
          name="filter_by_name-critical_asset"
          :value.sync="filter.aes__bcei__name"
          item_key="name"
          label="BCEI"
          append_icon="search"
        />
        <select-rq
          class="px-4"
          md="3"
          :name="rq_name"
          :value.sync="filter.bcei__organization"
          f_key="bcei__organization"
          item_key="name"
          value_key="id"
          label="Organización"
          :items="organizations"
          append_icon="search"
        />
        <combobox-rq
          :ex_filters="pr_fls"
          class="px-4"
          md="3"
          :main_name="rq_name"
          main_f_key="s__bcei__tag"
          name="filter_by_tag-critical_asset"
          :value.sync="filter.s__bcei__tag"
          item_key="tag"
          label="Tag BCEI"
          append_icon="search"
        />
        <debounce-select
          :ex_filters="pr_fls"
          class="px-4"
          md="3"
          :name="rq_name"
          :value.sync="filter.s__description"
          item_key="description"
          label="Descripción Sistema SPCI"
          append_icon="search"
        />
        <debounce-select
          :ex_filters="pr_fls"
          class="px-4"
          md="3"
          :name="rq_name"
          :value.sync="filter.s__functional_location"
          item_key="functional_location"
          label="FLOC SPCI"
          append_icon="search"
        />

        <!-- <debounce-select
          :ex_filters="pr_fls"
          class="px-4"
          md="3"
          :name="rq_name"
          :value.sync="filter.s__maintenance_plan_id"
          item_key="maintenance_plan_id"
          label="Maintenance Plan"
          append_icon="search"
        />
        <debounce-select
          :ex_filters="pr_fls"
          class="px-4"
          md="3"
          :name="rq_name"
          :value.sync="filter.s__maintenance_item_id"
          item_key="maintenance_item_id"
          label="Maintenance Item"
          append_icon="search"
        /> -->
    </v-layout>
    <div>
      <s_table :type="type" :ex_refresh.sync="ex_refresh">
    </s_table>
    </div>
  </div>
</template>
<script>
import s_table from './table.vue';
import filter from '@/components/mixins/filter';

export default {
  props:['type'],
  mixins:[filter],
  components: {  s_table},
  data() {
    return {
      ex_refresh:false,
      selectedItem:{},
      count:0,
      asset_folder:'spci',
      export_name:'spci',
    };
  },
  watch:{
    'myRequestStatus.rq'(v){ if (v) this.set_count() }
  },
  computed: {
    organizations(){ return this.$store.getters.organizations },
    pr_fls(){ return {} },
    name() { return 'fire_protection_systems'},
    rq_name(){ return `${this.type}-${this.name}`},
  },
  created() {
    this.set_count();
  }, // created
  methods: {
    set_count(){ this.myRequestStatus.rq.then && this.myRequestStatus.rq.then(r=> {this.count = r.count; return r}) },
    new_item(){ this.$router.push({ name: `${this.asset_folder}/new`}) },    
  },
};
</script>
<style scoped>
  .btns{ text-align: end }
  .btns>*{ vertical-align: top }
</style>
